import React from 'react'
import { useHistory } from 'react-router-dom'
import { LEGALS_VERSION } from '@mote/helpers/constants'
import { useGoalsState } from '@mote/helpers/hooks/business'
import { useAuth } from '../../auth'
import { DashboardLayout } from '../../layouts'
import { ScreenSpinner } from '../../shared'
import { OnboardingProduct } from './OnboardingProduct'

const MODES = {
  PRODUCT: 'PRODUCT',
  HOME: 'HOME'
}

export const DashboardScreen = () => {
  const history = useHistory()
  const { user } = useAuth()
  const [mode, setMode] = React.useState(null)
  const goalsState = useGoalsState()

  React.useEffect(() => {
    if (!user) return

    if (
      goalsState.userOnboardingRequired ||
      (!goalsState.userOnboardingSkipped && user?.legals < LEGALS_VERSION)
    ) {
      history.push('/onboarding')
    } else if (
      goalsState.productOnboardingRequired &&
      !(user.isInstitutionalAdmin && !user.isPaid)
    ) {
      setMode(MODES.PRODUCT)
    } else if (
      goalsState.onboardingComplete ||
      (user.isInstitutionalAdmin && !user.isPaid)
    ) {
      history.push('/account')
    }
  }, [user, history, goalsState])

  return (
    <DashboardLayout>
      {!mode && <ScreenSpinner />}
      {mode === MODES.PRODUCT && <OnboardingProduct />}
    </DashboardLayout>
  )
}
